import { useScrollReveal } from '../../../hooks/useScrollReveal';
import { steps } from '../../../mocks/asesoriaImagen';

export default function StepsSection() {
  const { ref, style } = useScrollReveal({
    threshold: 0.1,
    distance: 32,
    duration: 800,
  });
  const { ref: refGrid, style: styleGrid } = useScrollReveal({
    threshold: 0.1,
    distance: 28,
    duration: 800,
    delay: 200,
  });

  return (
    <section className="w-full bg-white py-20 md:py-28 px-6 lg:px-[7%]">
      <div ref={ref} style={style} className="max-w-3xl">
        <span className="font-sans text-brand-gray-500 text-[11px] tracking-[0.2em] uppercase font-medium">
          Cómo funciona
        </span>
        <h2 className="font-serif text-brand-black text-[clamp(1.8rem,4vw,2.8rem)] leading-[1.3] mt-4">
          Seis pasos. Una transformación real.
        </h2>
      </div>
      <div
        ref={refGrid}
        style={styleGrid}
        className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mt-12"
      >
        {steps.map((s) => (
          <div
            key={s.id}
            className="bg-brand-cream rounded-2xl p-6 md:p-8 border border-brand-gray-200"
          >
            <div className="flex items-start gap-4">
              <span className="font-serif text-brand-sage text-3xl font-light leading-none">
                {s.number}
              </span>
              <div>
                <h3 className="font-serif text-brand-black text-lg font-medium">
                  {s.title}
                </h3>
                <p className="font-sans text-brand-gray-500 text-sm leading-relaxed mt-2">
                  {s.description}
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}